<div class="cart-share-tooltip">
  <span class="text-b3-m-300">ссылка на корзину скопирована</span>
  <button class="btn-icon" (click)="close()" data-testid="cart-share-tooltip-close">
    <sd-icon [type]="iconTypes.CROSS" class="icon-size-xs"></sd-icon>
  </button>
</div>
